import { createLogger } from "utils/logging";
import { addLoadedTracking, addMiniActionsToVisibilityChanges, initBenefitExpiryCleanup } from "../utils";
import type { Debug } from "@otto-ec/global-resources/debug";
const log = createLogger("cinema", "module");

/*                                                                                                    */
/*                                                                              */
const MAX_CLEANUP_PERIOD_IN_MILLIS = 20 * 24 * 60 * 60 * 1000;
const PARENT_ID = "FT9-benefit-main";
const ROOT_SELECTOR = "#ft9_benefit_cinema__root";

export class Cinema {
	init(featureOrder: number) {
		log.info("Initialize cinema-module");

		const cinema = document.querySelector<HTMLOcCinemaV1Element>(`[data-module*=ft9-benefit-cinema]`);
		if (!cinema) {
			return log.info("no cinema found");
		}

		log.info("initialize first cinema found");

		/*                                                                                      */
		/*                                                                                             */
		cinema.addEventListener("tr-submit-tracking", ({ detail }) => {
			switch (true) {
				case detail.eventName === "tr-become-visible" && detail.method === "submitMiniAction":
					addMiniActionsToVisibilityChanges(detail, cinema, "scroll", PARENT_ID);
					break;
				case detail.eventName === "oc-item-visibility-changed" && detail.method === "submitMiniAction":
					if (detail.event.detail.scrollDirection === "left") {
						detail.abort();
						return;
					}
					log.info("cinema slide changed");
					addMiniActionsToVisibilityChanges(detail, cinema, "next", PARENT_ID);
					break;
				case detail.eventName === "tr-page-impression" && detail.method === "submitMerge":
					addLoadedTracking(detail, cinema, featureOrder, log as unknown as Debug<string>, PARENT_ID);
					break;
				default:
					break;
			}
		});

		initBenefitExpiryCleanup(cinema, MAX_CLEANUP_PERIOD_IN_MILLIS, ROOT_SELECTOR);
	}
}
